const isDefined = styleObj => value => styleObj[value] !== undefined;
const camelToDash = name => name.replace(/[A-Z]/g, a => `-${a}`).toLowerCase();
const pixelize = value => value + (value.toFixed ? 'px' : '');
const toCSSRule = styleObj => propName =>
  `${camelToDash(propName)}:${pixelize(styleObj[propName])};`;
const toCSS = styleObj =>
  '{' +
  Object.keys(styleObj)
    .filter(isDefined(styleObj))
    .map(toCSSRule(styleObj))
    .join('') +
  '}';

export default toCSS;
